// RTK have it's own actions. These action creaters are specifically for sagas
import { createAction } from '@reduxjs/toolkit';

interface GetDocumentsPayload {
  projectId: number;
}

export const getDocuments = createAction<GetDocumentsPayload>(
  'documents/saga/get-documents',
);
